module.exports = __webpack_public_path__ + "img/신논현 피자.8022a40c.png";